import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import BootstrapVue from 'bootstrap-vue'
import VueAnime from 'vue-animejs';
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserAstronaut,faUserNinja,faUserTie,faFlask} from '@fortawesome/free-solid-svg-icons'
import * as d3 from 'd3'
import * as THREE from "three";
import VueAnalytics from 'vue-analytics'




import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserAstronaut,faUserNinja,faUserTie,faFlask)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.min.css'


Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueAnime);
Vue.use(VueMaterial);
Vue.use(d3);
Vue.use(VueAnalytics, {
  id: 'UA-48113326-1',
  router
})
Vue.use(THREE)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
